import FormSendCryptoActions from './Form.WalletAddressActions';
import FormSendCryptoInputs from './Form.WalletAddressInputs';

const FormWalletAddress = () => (
	<div className='payment-request-form_usdDestination_send-crypto new-drop-down-input'>
		<FormSendCryptoInputs />

		<FormSendCryptoActions />
	</div>
);

export default FormWalletAddress;
